<template>
    <a-popover
        :visible="open"
        :overlayClassName="'no-padding common-filter-item-popup'"
        placement="bottom"
        @visibleChange="(isVisible) => (open = readonly ? false : isVisible)"
        trigger="click"
    >
        <div slot="content" style="width: auto">
            <div class="common-filter-item-form">
                <div class="common-filter-item-form-title">
                    <span class="material-icons closeIcon" @click="close"> close </span>

                    <span class="material-icons filterIcon" v-if="materialIcon"> {{ materialIcon }} </span>
                    <component :is="icon" v-else-if="!!icon" />
                    <span class="filterName ml-2">{{ label }}</span>
                </div>
                <div class="w-100" v-if="controlType === 'select'">
                    <a-select
                        :value="clone.filterValue"
                        @select="handleSelect"
                        class="select-story"
                        :placeholder="$t('chatbotv2.select')"
                        :filter-option="false"
                    >
                        <a-select-option
                            v-for="(option, i) of getSelectOptions()"
                            :value="option.id"
                            :key="option.id || 'option' + i"
                            @click="() => selectOptionClick(option.id)"
                        >
                            <span class="blockTypeText">{{ option.label }}</span>
                        </a-select-option>
                    </a-select>
                </div>
                <div class="d-flex gap-5" v-if="controlType === 'input'" style="width: 400px">
                    <a-select v-model="clone.operator" class="w-100" style="width: 200px">
                        <a-select-option v-for="operator in availableOperators" :key="operator" :value="operator">
                            {{ operator }}
                        </a-select-option>
                    </a-select>
                    <div class="col-md-8" v-if="clone.operator !== 'empty' && clone.operator !== 'non_empty'">
                        <a-input :value="clone.filterValue" @change="handleInputChange" />
                    </div>
                </div>
                <div class="w-100" v-if="controlType === 'text-input'" style="min-width: 250px">
                    <a-input
                        :value="clone.filterValue"
                        @change="handleInputChange"
                        :placeholder="label"
                        allowClear
                    />
                </div>
                <div class="custom-picker-filter-wrapper" v-if="controlType === 'custom-picker'">
                    <CustomPickerInline
                        v-model="clone.filterValue"
                        v-bind="getControlProps()"
                        :items="getSelectOptions()"
                    />
                </div>
                <div class="agent-picker-filter-wrapper" v-if="controlType === 'agent-picker'">
                    <AgentPicker v-model="clone.filterValue" v-bind="getControlProps()" />
                </div>
                <div class="department-picker-filter-wrapper" v-if="controlType === 'department-picker'">
                    <DepartmentPickerInline v-model="clone.filterValue" v-bind="getControlProps()" />
                </div>
                <div class="department-picker-filter-wrapper" v-if="controlType === 'tags-picker'">
                    <TagPickerInline v-model="clone.filterValue" v-bind="getControlProps()" />
                </div>

                <div class="channel-picker-filter-wrapper" v-if="controlType === 'channel-picker'">
                    <ChannelPickerInline v-model="clone.filterValue" v-bind="getControlProps()" />
                </div>
                <div class="date-ranger-picker-filter-wrapper" v-if="controlType === 'date-range-picker'">
                    <DateRangerPickerInline v-model="clone.filterValue" v-bind="getControlProps()" />
                </div>
                <div style="margin-top: 20px; width: 100%" class="w-100">
                    <!--                    <a-button type="primary" class="d-block w-100" :disabled="!isChanged()" @click="saveValue"-->
                    <!--                        >{{ $t("chatbotv2.applyFilter") }}-->
                    <!--                    </a-button>-->
                    <SupsisButton primary small block :disabled="!isChanged()" @click="saveValue">
                        {{ $t("chatbotv2.applyFilter") }}
                    </SupsisButton>
                </div>
            </div>
        </div>

        <div class="filter-wrapper-preview" :class="{ readonly }" :data-filter-name="name">
            <span class="material-icons mainIcon" v-if="materialIcon"> {{ materialIcon }} </span>
            <component class="material-icons mainIcon" :is="icon" v-else-if="!!icon" />
            <span class="material-icons closeIcon" @click="remove"> close </span>
            <span text-truncate="" text-actions="">
                <span text-weight="semi-bold"></span>
                <span class="filter-value-text">{{ getLabel() }}</span>
            </span>
        </div>
    </a-popover>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import log2 from "../../../../../utils/log2";
import { mapState, mapMutations } from "vuex";
import moment from "moment/moment";
import AgentPicker from "../../../../../components/pickers/AgentPicker.vue";
import DepartmentPickerInline from "../../../../../components/pickers/DepartmentPickerInline.vue";
import ChannelPickerInline from "../../../../../components/pickers/ChannelPickerInline.vue";
import DateRangerPickerInline from "../../../../../components/pickers/DateRangerPickerInline.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import CustomPickerInline from "../../../../../components/pickers/CustomPickerInline.vue";
import TagPickerInline from "../../../../../components/pickers/TagPickerInline.vue";

const log = log2("CommonFilterItem");
export default {
    name: "CommonFilterItem",
    components: {
        TagPickerInline,
        CustomPickerInline,
        SupsisButton,
        DateRangerPickerInline,
        AgentPicker,
        DepartmentPickerInline,
        ChannelPickerInline,
    },
    props: {
        value: {
            required: true,
        },
        name: {
            type: String, //period,story,integration,visitorId
            required: true,
        },
        filterValue: {
            type: String | Number | Object | Array,
        },

        label: {
            type: String,
            required: true,
        },
        onRemoved: {
            type: Function,
            required: true,
        },
        onFinished: {
            type: Function,
            required: true,
        },
        defaultOpen: {
            type: Boolean,
            required: false,
            default: false,
        },
        autoRemoveWhenCancel: {
            type: Boolean,
            required: false,
            default: false,
        },
        controlType: {
            type: String,
            default: "input", //input,select
        },
        options: {
            //Array or function
            type: Array | Function,
            required: false,
            default: () => [],
        },
        materialIcon: {
            type: String,
        },
        icon: {
            type: String,
        },
        labelFormatter: {
            type: Function,
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        removeable: {
            type: Boolean,
            required: false,
            default: true,
        },
        availableOperators: {
            type: Array,
            default: () => ["equal"], //"equal","not_equal","contain","not_contain","starts_with","ends_with","empty","non_empty","longer_than","shorter_than","less_than","less_or_equal","greater_than","greater_or_equal"
        },
    },
    data() {
        const dateRange = {};

        if (this.value === "custom") {
            dateRange.start = moment().subtract(1, "day").startOf("day");
            dateRange.end = moment().endOf("day");
        } else {
            // dateRange.start = this.startDate;
            // dateRange.end = this.endDate;
        }
        return {
            open: this.defaultOpen,
            clone: _.cloneDeep(this.value),
            cancels: [],
            periods: [
                { value: "today" },
                { value: "yesterday" },
                { value: "last7" },
                { value: "last30" },
                { value: "this-month" },
                { value: "last-month" },
                { value: "last-3-month" },
                { value: "this-year" },
                { value: "last-year" },
                { value: "custom" },
            ],
            integrations: [
                { value: "web", name: "Supsis Widget" },
                { value: "whatsapp", name: "WhatsApp" },
            ],
            dateRange: dateRange,
        };
    },
    created() {
        // Eğer operator prop'da verilmemişse varsayılan olarak 'equal' kullan
        if (!this.clone.operator) {
            this.clone.operator = "equal";
        }
    },
    methods: {
        getControlProps() {
            return _.get(this.clone, "controlProps", {});
        },
        getLabel() {
            if (this.labelFormatter) {
                return this.labelFormatter(this.name, this.filterValue);
            }
            return this.clone.label;
        },
        getSelectOptions() {
            if (typeof this.options === "function") {
                return this.options();
            }
            return this.options;
        },
        remove(e) {
            if (!this.removeable) return;
            if (this.readonly) return;
            e.stopPropagation();
            e.preventDefault();
            this.clone = undefined;
            this.dateRange = {};
            this.onRemoved();
        },
        saveValue() {
            log("saveValue", { clone: this.clone });
            this.$emit("input", _.cloneDeep(this.clone));
            this.onFinished();
            this.open = false;
        },
        handleSelect(val) {
            log("handleSelect", val);
            this.clone.filterValue = val;
        },
        selectOptionClick(type) {
            if (this.clone === type) {
                this.clone.filterValue = undefined;
            }
        },
        isChanged() {
            return !_.isEqual(this.value, this.clone);
        },
        close() {
            this.open = false;
            if (this.autoRemoveWhenCancel) {
                this.onRemoved();
            }
        },
        handleInputChange(event) {
            this.clone.filterValue = event.target.value;
        },
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
    },
    mounted() {
        log("clone value", this.clone);

        const keydownCallback = (e) => {
            if (e.key === "Escape") {
                this.open = false;
            }
        };
        document.addEventListener("keydown", keydownCallback);
        this.cancels.push(() => {
            document.removeEventListener("keydown", keydownCallback);
        });
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
        this.cancels = [];
    },
    watch: {
        defaultOpen(newVal) {
            this.open = newVal;
        },
        clone(newVal) {
            log("clone", newVal);
        },
        open(newVal) {
            if (newVal) {
                this.$nextTick(() => {});
            }
        },
        value(newVal) {
            log("value changed", newVal);
            const isChanged = !_.isEqual(newVal, this.clone);
            if (isChanged) {
                this.clone = _.cloneDeep(newVal);
            }
        },
    },
};
</script>

<style lang="scss">
.common-filter-item-form {
    align-items: flex-start;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    min-width: 325px;
    padding: 20px;
    position: relative;
    text-align: left;
    box-shadow: 2px 2px 2px 2px #0000001f;

    .custom-picker-filter-wrapper {
        width: 100%;
    }

    .agent-picker-filter-wrapper {
        width: 100%;
    }

    .department-picker-filter-wrapper {
        width: 100%;
    }

    .channel-picker-filter-wrapper {
        width: 100%;
    }

    .date-ranger-picker-filter-wrapper {
        width: 100%;
    }

    .common-filter-item-form-title {
        align-items: center;
        cursor: default;
        display: flex;
        margin-bottom: 20px;
        width: 100%;

        .closeIcon {
            color: #008aff;
            cursor: pointer;
            font-size: 19px;
            position: absolute;
            right: 20px;
            top: 20px;
            transition: all 0.3s;
        }

        .filterIcon {
            color: #006cff;
            font-size: 16px;
            margin-right: 10px;
            position: relative;
            top: 1px;
        }

        .filterName {
            color: #22272d;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }
    }
}

.common-filter-item-popup {
    .select-story {
        width: 100%;

        //.ant-select-selection {
        //    background: #354961;
        //    border-color: #354961;
        //}

        //.anticon {
        //    color: #9ba6b3;
        //}

        //.ant-select-selection-selected-value {
        //    .blockTypeText {
        //        color: white !important;
        //    }
        //}

        &.ant-select-open {
            .blockTypeText {
                color: #000 !important;
            }
        }
    }
}
</style>
<style scoped lang="scss">
.filter-content {
    padding: 20px;
}

.filter-wrapper-preview {
    align-items: center;
    background: #22272d;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    height: 32px;
    padding: 10px;
    transition: all 0.3s;
    white-space: nowrap;
    width: max-content;

    &.readonly {
        cursor: default;
        opacity: 0.8;
    }

    [text-truncate] {
        overflow: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    [text-actions] {
        cursor: pointer;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
    }

    &:hover {
        opacity: 0.8 !important;

        .material-icons {
            &.mainIcon {
                display: none;
            }

            &.closeIcon {
                display: inherit;
            }
        }
    }

    .material-icons {
        font-size: 15px;
        margin-right: 10px;

        &.mainIcon {
            display: inherit;
        }

        &.closeIcon {
            display: none;
        }
    }
}
</style>
